import { Component, OnInit, OnChanges, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { filter, map } from 'rxjs/operators';

import { DeviceDetectorService } from 'ngx-device-detector';


import {
  IApplication,
  IContact,
  IContactInput,
  IUser,
  IHelp,
  HelpApiService,
  IProgramCycle,
  IDwelling,
  DialogSolutionDeployingComponent,
  IAppdwellingWithdrawn,
  INotification,
  NotificationApiService
} from '@ebb-v2/ebb-integration';
import {
  AuthenticationService, ContactApiService,
  ApplicationApiService, DwellingApiService,
  CrossSiteNavigationService
  
} from '../data-services/index';
import { DOCUMENT } from '@angular/common';
import { forkJoin, Observable } from 'rxjs';
import { ImportJobApiService } from '../data-services/importjob-api.service';
import { SolutionHistoryApiService } from '../data-services/solutionhistory-api.service';

import {
  ListApplicationsQuery,
  ListInspectionCompleteApplicationsQuery
} from '@ebb-v2/ebb-integration';

import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyInput as MatInput } from '@angular/material/legacy-input';
import { cloneDeep } from '@apollo/client/utilities';

@Component({
  selector: 'ebb-portal-application-home',
  templateUrl: './application-home.component.html'
})
export class ApplicationHomeComponent
  implements OnInit, OnChanges, AfterViewInit {
  public applications: IApplication[] = [];
  public currentApplications: IApplication[] = [];
  public newApplications: IApplication[] = [];
  public activeApplications: IApplication[] = [];
  public withdrawnApplications: IApplication[] = [];
  public withdrawnappDwellings : IAppdwellingWithdrawn[] =[];
  public completedApplications: IApplication[] = [];
  public closedApplications: IApplication[] = [];
  public listSearch: IApplication[] = [];
  public toggleOpenClosedProjects = true;
  public toggleInspectedProjects = false;
  public displaySearchInput = false;
  public toggleDisplayCardList = true; // Show cards === true; Show list === false;
  public formSearch: FormGroup;
  public innerWidth: number;

  public currentDwellings: IDwelling[] = [];
  public currentWithdrawnDwellings: IDwelling[] = [];
  public notifications: INotification[] = [];
  public shownotifications: INotification[] = [];
  public contactNotifications: INotification[] = [];
  public currentUser: IUser;
  public currentContact: IContact;

  public listHelp: IHelp[] = [];
  public textFemaTrainingContractor: string;
  public textProfileNeedsUpdate: string;
  public textHomeownerDwellingQualified: string;

  public femareviewmessage: string;

private readonly HOMEOWNER = '700000000';
private readonly CONTRACTOR = '700000001';

  @ViewChild('searchPhrase', { read: MatInput }) searchPhrase: MatInput;

  public checkForOpenApplications = 'Loading...';
  public checkForNewApplications = 'Loading...';
  public checkForClosedApplications = 'Loading...';

  public programTypeCodeOptionSet: string;
  public programCycleMultipleDwellingsAllowed: boolean;
  public programCycles: IProgramCycle[];
  public uriSpaRegistration: string;
  public expiredPolicy = false;
  private dialogRef;
  public dialogRefCount = 0;

  public ebbTrainingUrl: string;
  public essTrainingUrl: string;
public visibleNotifications :boolean;
  constructor(
    private readonly deviceService: DeviceDetectorService,
    private readonly router: Router,
    private route: ActivatedRoute,
    private readonly authenticationService: AuthenticationService,
    private readonly xSiteNavigationService: CrossSiteNavigationService,
    private readonly apiContact: ContactApiService,
    private readonly apiApplication: ApplicationApiService,
    private readonly apiDwelling: DwellingApiService,
    private readonly apiHelp: HelpApiService,
    private readonly fb: FormBuilder,
    private readonly dialogSolutionDeploying: MatDialog,
    private readonly apiImportJob: ImportJobApiService,
    private readonly apiSolutionHistory: SolutionHistoryApiService,
    private readonly apiNotification: NotificationApiService,

    @Inject(DOCUMENT) private document: Document
  ) {
    this.route.queryParams.subscribe(() => {
      const programLocalStore = localStorage.getItem('ebbprogram');
      if (window['program']) {
        this.programTypeCodeOptionSet = window['program'];
      } else if (programLocalStore) {
        this.programTypeCodeOptionSet = programLocalStore;
      } else {
        this.programTypeCodeOptionSet = 'FEMA|EBB'; //default to EBB programs
      }
    });
  }

  async ngOnInit() {    
    this.innerWidth = window.innerWidth;
    //console.log('innerWidth=' + this.innerWidth);
    this.currentUser = this.authenticationService.currentUserValue;
    this.uriSpaRegistration = this.authenticationService.uriSpaRegister;
    const hostName = window.location.hostname;
    if(hostName.includes("earthquakeauthority")){
      this.uriSpaRegistration ="/prepare-your-house-earthquake-risk/brace-and-bolt-grants/cea-policyholder-brace-bolt-grants/register/";
    }
    this.programCycles = this.route.snapshot.data['programCycles'];
    await this.getContact(this.currentUser.id);
   

    this.loadHelpText();
    this.initializeForms();
const { notifications, contactNotifications } = await this.fetchAndPrepare(this.currentUser.id);
    this.ebbTrainingUrl = this.xSiteNavigationService.ebbSiteUrl(
      '/Contractors-Design-Professionals/FEMA-Education-Course', this.currentUser
    );
    this.essTrainingUrl = this.xSiteNavigationService.essSiteUrl(
      '/Contractors-Design-Professionals/FEMA-Education-Course', this.currentUser
    );
 
    forkJoin([this.apiApplication.getApplicationListByType((this.isInspector() && this.toggleInspectedProjects)?ListInspectionCompleteApplicationsQuery:ListApplicationsQuery), this.apiDwelling.getDwellingList()])
    .subscribe(results => {
        var applications= cloneDeep(results[0]);
      this.currentDwellings = results[1].filter(d => d.stateCode === 0
        && (d.statusCode === 700000000 || d.statusCode === 700000002));
  
      this.applications = this.FilterForType(this.currentUser, results[0].filter(x => x.statusCode !== 700000004));
try {
   

    // Contractor path
    if (this.isContractor()) {
      const withHide = this.applyContractorHideRules(notifications);
      const shown = this.filterByDashboardType(withHide, this.CONTRACTOR)
        .filter(n => !this.isAcknowledged(contactNotifications, n.id));
      this.setShown(shown);
    
    }

    // Homeowner-only path
    if (this.isHomeowner()) {
      const shown = this.filterByDashboardType(notifications, this.HOMEOWNER)
        .filter(n => !this.isAcknowledged(contactNotifications, n.id))
        .map(n => this.applyHomeownerProgramRules(n));     
          this.setShown(shown);
      
    }

    if(!this.isHomeowner() && !this.isContractor()) { 
    // Fallback (neither role matched)
    this.setShown([]);}
  } catch (err) {
    console.error('loadNotifications() failed:', err);
    this.resetNotifications();
  }
    
      if (this.expiredPolicy === false) {
        this.currentApplications = this.FilterForType(this.currentUser, results[0]);
        if (
          this.isHomeowner() &&
          this.currentApplications.length === 1 &&
          this.currentApplications[0].statusCodeOptionSet !== 'Withdrawn' &&
          this.currentDwellings.length === 0 && !this.visibleNotifications
        ) {
          this.router.navigate(['application', this.currentApplications[0].id]);
        } else {
          this.processApplicationList(this.FilterForType(this.currentUser, results[0]));
        }

        if (
          this.currentContact &&
          !this.currentContact.isContractor &&
          this.activeApplications.length > 0
        ) {
          const programsSplit = this.programTypeCodeOptionSet.split('|');

          //if multiple programs are active at the same time then FEMA is default
          const availablePrograms = this.programCycles.filter(program =>
            programsSplit.includes(program.typeCodeOptionSet)
          );
          const availableFemaProgram = availablePrograms.filter(
            program => program.typeCodeOptionSet === 'FEMA'
          )[0];

          if (
            (availableFemaProgram && availableFemaProgram.multipleDwellings) ||
            (availablePrograms[0] && availablePrograms[0].multipleDwellings)
          ) {
            this.programCycleMultipleDwellingsAllowed = true;
          } else {
            this.programCycleMultipleDwellingsAllowed = false;
          }
        }
      }
    });
    if (
      this.isHomeowner()){
    this.apiDwelling.getWithdrawnDwellingList().subscribe(_data => {
      var data = cloneDeep(_data)
      
   this.currentWithdrawnDwellings =[];
      this.currentWithdrawnDwellings = data;
    });}
  }
private resetNotifications(reason?: string): void {
  if (reason) console.error(reason);
  this.notifications = [];
  this.contactNotifications = [];
  this.shownotifications = [];
  this.visibleNotifications = false;
}
  private FilterForType(user: IUser, applications: IApplication[]) : IApplication[] {
    if(this.authenticationService.isContractor(user))  {
      return applications.filter(x => x._Ebb_ContractorId === user.id);
    }

    if(this.authenticationService.isHomeowner(user))  {
      return applications.filter(x => x._Ebb_OwnerId === user.id)
    }

    return applications;
  }

  ngAfterViewInit() {}

  ngOnChanges() {
    this.apiApplication.getApplicationList()
    .subscribe(_data => {
      var data = cloneDeep(_data)
      data = data.filter(x => x.statusCode !== 700000004);

      this.currentApplications = data;
      if (
        this.isHomeowner() &&
        this.currentApplications.length === 1 && !this.visibleNotifications 
      ) {
        this.router.navigate(['application', this.currentApplications[0].id]);
      } else {
        this.processApplicationList(data);
      }
    });
    this.apiHelp.setCurrentHelpTopicValue('General Help');
  }

  private processApplicationList(applications: IApplication[]): void {
    this.newApplications = [];
    this.activeApplications = [];
    this.closedApplications = [];
    this.checkForOpenApplications = '';
    this.checkForClosedApplications = '';

this.withdrawnApplications =[];
this.completedApplications=[];
    if(this.isHomeowner()){
      applications.forEach(_i => { 
        var i=    cloneDeep(_i)
        
        
        if (i.stateCode === 0) {
        this.activeApplications.push(i);
      } else if (i.stateCode === 1) {
        if (i.statusCode === 700000001) {
          this.withdrawnApplications.push(i);
        } else if (i.statusCode === 700000000) {
          this.closedApplications.push(i);
          this.completedApplications.push(i);
        }else{
          this.activeApplications.push(i);
        }
    }
  });}
    if (this.isContractor()) {
      applications.forEach(_i => {
      // this.mapdisplayStatus(i);
  var i=    cloneDeep(_i)
        if(i.stateCode === 0) {
          switch (i.stageCode) {
            case 700000000:
              i.displayretrofitdue = this.getFormattedDate(i.preRetrofitDue.toString());
              if(i.applicationStatusOptionSet !== 'Extension' && i.programType !== 700000002){
                i.displaystatus ='Pre-retrofit';
              }
              else if (i.applicationStatus === 700000009) {
              i.displaystatus = 'FEMA Review';
              }
              else if (i.applicationStatusOptionSet === 'Extension') {
                i.displaystatus = 'Extension';
              }
              break;
            case 700000001:
              i.displayretrofitdue = this.getFormattedDate(i.postRetrofitDue.toString());
              i.displaystatus ='Post-retrofit';
              break;
            case 700000002:
              i.displaystatus ='Application In Review';
              break;
            case 700000003:
              i.displaystatus ='Application In Review';
              break;

          }
        }
        if( i.stateCode === 1){
          switch (i.statusCode) {
            case 700000000:
              i.displaystatus ='Paid';
              break;
            case 700000001:
              i.displaystatus ='Withdrawn';
              break;
            default:
              break;
          }
        }
        if(this.isInspector()){
          i.displaystatus ='Inspection Requested';
        }

        if (i.contractorInvitationCode === 700000001 && i.statusCode !== 700000001) {
          this.newApplications.push(i);
        } else if (i.stateCode === 0) {
          if(i.contractorInvitationCode !== 700000003){
          this.activeApplications.push(i);}
        } else if (i.stateCode === 1) {
          if (this.isHomeowner()) {
            this.activeApplications.push(i);
          } else if (i.statusCode === 700000000) {
            this.closedApplications.push(i);
          }
        } 
      });
      if(this.isHomeowner()){
        applications.forEach(_i => { 
          var i=    cloneDeep(_i)
          
          
          if (i.stateCode === 0) {
          this.activeApplications.push(i);
        } else if (i.stateCode === 1) {
          if (i.statusCode === 700000001) {
            this.withdrawnApplications.push(i);
          } else if (i.statusCode === 700000000) {
            this.closedApplications.push(i);
            this.completedApplications.push(i);
          }else{
            this.activeApplications.push(i);
          }
      }})};
      if (this.activeApplications && this.activeApplications.length > 0) {
      } else {
        this.checkForOpenApplications =
          'No open projects found for this account.';
      }
      if (this.newApplications && this.newApplications.length > 0) {
      } else {
        this.checkForNewApplications =
          'No new projects found for this account.';
      }
      if (this.closedApplications && this.closedApplications.length > 0) {
      } else {
        this.checkForClosedApplications =
          'No completed projects found for this account.';
      }
     
    } else if (this.currentContact.isInspector) {
      if (applications && applications.length > 0) {
        this.activeApplications = [...applications];
      } else {
        this.activeApplications = [];
        this.checkForOpenApplications =
          'No applications require inspection at this time.';
      }

      if (this.activeApplications && this.activeApplications.length > 0) {
      } else {
        this.checkForOpenApplications =
          'No applications require inspection at this time';
      }
    } else {
      
      if (this.activeApplications && this.activeApplications.length > 0) {
        
      } else {
        this.activeApplications = [];
        this.checkForOpenApplications =
          'No accepted application found for this account.';
      }
    }
  }

 private initializeForms(): void {
  this.formSearch = this.fb.group({
    searchPhrase: ['']   
  });

  this.formSearch
    .get('searchPhrase')!
    .valueChanges
    .subscribe(phrase => this.searchProjectListByPhrase(phrase));
}


  public getFormattedDate(input: string): string {
    const permitDateUTC = new Date(input);
    permitDateUTC.setHours(permitDateUTC.getHours() + 8);

    const permitDatePST = new Date(permitDateUTC);

    const year = permitDatePST.getFullYear();

    let month = (1 + permitDatePST.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    let day = permitDatePST.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    return `${month}/${day}/${year}`;
  }

  private searchProjectListByPhrase(phrase: string): void {
    if (phrase.length) {
      this.listSearch = this.currentApplications.filter(
        (application: IApplication) =>
          (application._Ebb_OwnerId_Formatted?application._Ebb_OwnerId_Formatted:'')
            .toLowerCase()
            .startsWith(phrase.toLowerCase()) !== false ||
          (application._Ebb_OwnerId_Formatted?application._Ebb_OwnerId_Formatted:'')
            .toLowerCase()
            .includes(' ' + phrase.toLowerCase()) !== false ||
          application.name.toLowerCase().startsWith(phrase.toLowerCase()) !==
            false ||
          application.name
            .toLowerCase()
            .includes(' ' + phrase.toLowerCase()) !== false ||
          application.applicationNumber.startsWith(phrase) !== false
      );
      this.processApplicationList(this.listSearch);
    } else {
      this.processApplicationList(this.currentApplications);
    }
  }

  public isHomeowner() {
    return this.authenticationService.isHomeowner(this.currentUser);
  }

  public isContractor() {
    return this.authenticationService.isContractor(this.currentUser);
  }

  public isInspector() {
    return this.authenticationService.isInspector(this.currentUser);
  }

  public onClickOpenApplication(id: string): void {
    this.router.navigate(['application', id]);
  }

  public goToUrl(url: string): void {
    this.document.location.href = url;
  }

private getContact(currentId: string): Promise<void> {
  const isMobile = this.deviceService.isMobile();
  const isTablet = this.deviceService.isTablet();

  return this.apiContact.getContact(currentId).toPromise()
    .then(async data => {
      this.currentContact = cloneDeep(data);
     
      this.evaluateDisplayCard(isMobile, isTablet);
    })
    .catch(error => console.warn(`ERROR: UserAccount.getContact() - ${error}`));
}

private evaluateDisplayCard(isMobile: boolean, isTablet: boolean): void {
  if (this.currentContact?.isContractor === true && (isMobile || isTablet)) {
    this.toggleDisplayCardList = true;
  } else if (
    (this.currentContact.personalizationDashboardHome &&
     parseInt(this.currentContact.personalizationDashboardHome.toString(), 10) === 700000000) ||
    this.currentContact.personalizationDashboardHome == null
  ) {
    this.toggleDisplayCardList = !this.currentContact.isInspector;
  } else {
    this.toggleDisplayCardList = !isMobile || !this.currentContact.isInspector;
  }
}
  // If a D365 solution is being deployed/imported, detect this and inform the user.
  private checkSolutionDeploying () {
    // Perform deployment status check, once.
    this.apiSolutionHistory
      .getSolutionHistoryList()
      .subscribe(
        solutionsApplying => {
          if (solutionsApplying.length > 0 && this.dialogRefCount <= 0) {
            this.dialogRef = this.dialogSolutionDeploying.open(DialogSolutionDeployingComponent, {
                  width: '400px',
                  disableClose: true
              }
            );
            this.dialogRefCount++;
          }
        },
        error => console.warn(`ERROR: ApplicationHomeComponent.checkSolutionDeploying() - ${error}`)
      );

      // Set up periodic deployment status checks.
      setInterval(
        () => {
          this.apiSolutionHistory
            .getSolutionHistoryList()
            .subscribe(
              solutionsApplying => {
                if (solutionsApplying.length <= 0 && this.dialogRefCount > 0) {
                  this.dialogRefCount = 0;
                  this.dialogRef.close();
                } else {
                  if (solutionsApplying.length > 0 && this.dialogRefCount <= 0) {
                    this.dialogRef = this.dialogSolutionDeploying.open(DialogSolutionDeployingComponent, {
                          width: '400px',
                          disableClose: true
                      }
                    );
                    this.dialogRefCount++;
                  }
                }
              },
              error => console.warn(`ERROR: ApplicationHomeComponent.checkSolutionDeploying() - ${error}`)
            );
        },
        60000
      );
  }

  public multipleAppsAllowed(): number {
    if (
      !this.isContractor() &&
      this.programCycleMultipleDwellingsAllowed
    ) {
      return 2;
    } else {
      return 1;
    }
  }
public isContractorLicenseIsValid():boolean{
  if(this.isContractor() && this.currentContact?.contractorLicenseIsValid === true){
return true;
  }
  return false;
}
  public ShowOpenApplications(): boolean {

if(!this.isContractorLicenseIsValid() && this.isContractor()){
  this.activeApplications =[];
return false;
}

    return (
      this.activeApplications &&
      this.activeApplications.length > 0 &&
      this.toggleOpenClosedProjects &&
      !this.expiredPolicy
    );
  }

  public ShowNewApplications(): boolean {

    if(!this.isContractorLicenseIsValid() && this.isContractor()){
      this.newApplications =[];
      return false;
      }
    return (
      this.newApplications &&
      this.newApplications.length > 0 &&
      this.toggleOpenClosedProjects
    );
  }

  public ShowOpenApplicationsMessage(): boolean {
 
    return (
      (this.activeApplications === null ||
        this.activeApplications.length === 0) &&
      !(
        this.currentContact &&
        this.currentContact.isContractor &&
        !this.currentContact.femaTrained
      ) &&
      this.toggleOpenClosedProjects
    );
  }

  public ShowClosedApplications(): boolean {
    return (
      this.isContractor() &&
      this.closedApplications &&
      this.closedApplications.length > 0 &&
      !this.toggleOpenClosedProjects
    );
  }
  public ShowWithdrawnApplications(): boolean {
   
    return (
      this.isHomeowner() &&
      this.withdrawnApplications &&
      this.withdrawnApplications.length > 0 
      
    );
  }
  public getWithdrawn(): IAppdwellingWithdrawn[] {
this.withdrawnappDwellings =[];


if(this.currentWithdrawnDwellings.length>0){
this.currentWithdrawnDwellings.forEach(d=>{
  const dw: IAppdwellingWithdrawn = {} as IAppdwellingWithdrawn;
  dw.id = d.id;
  dw.name = d.name;
  dw._Ebb_OwnerId = d._Ebb_OwnerId;
  dw._Ebb_OwnerId_Formatted =d._Ebb_OwnerId_Formatted;
  dw._Ebb_ProgramCycleId =d._Ebb_ProgramCycleId;
  dw._Ebb_ProgramCycleId_Formatted = d._Ebb_ProgramCycleId_Formatted;
  dw.withdrawnDate = d.withdrawnDate;
  this.withdrawnappDwellings.push(dw);
 
}); }
if(this.withdrawnApplications.length>0){
  this.withdrawnApplications.forEach(d=>{
    if(this.withdrawnappDwellings.filter(x=>x.name == d.name && x._Ebb_ProgramCycleId == x._Ebb_ProgramCycleId ).length ==0){
    const dw: IAppdwellingWithdrawn = {} as IAppdwellingWithdrawn;
    dw.id = d.id;
    dw.name = d.name;
    dw._Ebb_OwnerId = d._Ebb_OwnerId;
    dw._Ebb_OwnerId_Formatted =d._Ebb_OwnerId_Formatted;
    dw._Ebb_ProgramCycleId =d._Ebb_ProgramCycleId;
    dw._Ebb_ProgramCycleId_Formatted = d._Ebb_ProgramCycleId_Formatted;
    dw.acceptedDate = d.acceptedDate;
    dw.withdrawReason = d.dwelling.withdrawReason;
    dw.withdrawnDate = d.dwelling.withdrawnDate;
    this.withdrawnappDwellings.push(dw);
   
  }});
}

 
  return this.withdrawnappDwellings;

}
  public ShowCompletedApplications(): boolean {
    
    return (
      this.isHomeowner() &&
      this.completedApplications &&
      this.completedApplications.length > 0 
      
    );
  }
  public ShowClosedApplicationsMessage(): boolean {

   
    return (
      this.isContractor() &&
      (this.closedApplications === null ||
        this.closedApplications.length === 0) &&
      !this.toggleOpenClosedProjects
    );
  }

  private loadHelpText(): void {
    this.apiHelp.getList().subscribe(
      data => {
        this.listHelp = JSON.parse(JSON.stringify(data));

        const femaTrainingContractor =  this.getHelpTextItem(this.listHelp, 'contractorfematraining');
        this.textFemaTrainingContractor = femaTrainingContractor ? femaTrainingContractor.answer : '...';

        const profileNeedsUpdate =  this.getHelpTextItem(this.listHelp, 'profileneedsupdate');
        this.textProfileNeedsUpdate = profileNeedsUpdate ? profileNeedsUpdate.answer : '...';

        const femaReviewMessage =  this.getHelpTextItem(this.listHelp, 'femareviewmessage');
        this.femareviewmessage = femaReviewMessage ? femaReviewMessage.linkText : '...';

        const homeownerDwellingQualified =  this.getHelpTextItem(this.listHelp, 'HomeownerDwellingQualified');
        this.textHomeownerDwellingQualified = homeownerDwellingQualified ? homeownerDwellingQualified.answer : '...';
   
        this.apiHelp.setCurrentHelpTopicValue('General Help');
      },
      error => console.log(error)
    );
  }
private async fetchAndPrepare(contactId: string): Promise<{
  notifications: INotification[];
  contactNotifications: INotification[];
}> {
  // sequential for easier debugging (kept from your original)
  const notificationsRaw = await this.getNotifications();
  const contactNotificationsRaw = await this.getContactNotifications(contactId);

  const notifications: INotification[] = cloneDeep(notificationsRaw ?? []);
  const contactNotifications: INotification[] = cloneDeep(contactNotificationsRaw ?? []);

  // sort defensively by "order"
  notifications.sort((a, b) => (a?.order ?? 0) - (b?.order ?? 0));

  // expose on instance for other methods that rely on fields
  this.notifications = notifications;
  this.contactNotifications = contactNotifications;

  return { notifications, contactNotifications };
}
private setShown(list: INotification[]): void {
  this.shownotifications = list;
  this.visibleNotifications = list.some(n => n.hide === false || !n.hide);
}

/** Contractor: compute n.hide from AND/OR checkTags */
private applyContractorHideRules(input: INotification[]): INotification[] {
  if (!this.isContractor()) return input;

  return input.map(n => {
    const andTags = Array.isArray(n?.checkTagsAND) ? n.checkTagsAND : [];
    const orTags  = Array.isArray(n?.checkTagsOR)  ? n.checkTagsOR  : [];

    const hasAND = andTags.length > 0;
    const hasOR  = orTags.length  > 0;

    let hide = false;
    if (hasAND && hasOR) {
      hide = !this.checkTags(andTags) || !this.checkTags(orTags, /*isOR*/ true);
    } else if (hasAND) {
      hide = !this.checkTags(andTags);
    } else if (hasOR) {
      hide = !this.checkTags(orTags, /*isOR*/ true);
    } else {
      hide = false; // no constraints -> show
    }
    return { ...n, hide };
  });
}

/** Homeowner: if programTypes present, use checkHomeTags to set hide */
private applyHomeownerProgramRules(n: INotification): INotification {
  if (!this.isHomeowner() || this.isContractor()) return n;

  const types = Array.isArray(n?.programTypes) ? n.programTypes : [];
  if (types.length > 0) {
    const hide = this.checkHomeTags(types);
    return { ...n, hide };
  }
  return n;
}

/** Filter by dashboardTypes containing a code */
private filterByDashboardType(list: INotification[], code: string): INotification[] {
  return list.filter(n => this.listHasCode(n.dashboardTypes, code));
}

/** Does dashboardTypes include the code? (supports number/string mixing) */
private listHasCode(list: unknown, code: string): boolean {
  if (!Array.isArray(list)) return false;
  // prefer exact match; change to .includes(String(code)) if you truly need substring matching
  return list.some(item => String(item) === code);
}

/** Has the user acknowledged this notification? */
private isAcknowledged(contactNotifications: INotification[], id?: string): boolean {
  if (!id || !Array.isArray(contactNotifications)) return false;
  // adjust property here if your contactNotifications use a different id field
  return contactNotifications.some(cn => cn.id === id);
}
private async getNotifications(): Promise<INotification[]> {
  const raw = this.apiNotification.getList().toPromise();
  return raw ? [...await raw] : [];
}

private async getContactNotifications(contactId: string): Promise<INotification[]> {
  const raw = this.apiNotification.getContactNotifications(contactId).toPromise();
  return raw ? [...await raw] : [];
}


private checkTags(tags: string[], useOrCondition: boolean = false): boolean {
  const conditions: { [key: string]: boolean } = {
    "700000000": this.currentContact.femaTrained,                   // Show EBB Training Completed
    "700000001": !this.currentContact.femaTrained,                  // Show EBB Training Not Completed
    "700000002": this.currentContact.essFemaTrained,                // Show ESS Training Completed
    "700000003": !this.currentContact.essFemaTrained,               // Show ESS Training Not Completed
    "700000004": this.currentContact.contractorLicenseIsValid,      // Show License Valid
    "700000005": !this.currentContact.contractorLicenseIsValid,     // Show License Not Valid
    "700000006": this.currentContact.contractorInDirectory,         // Show In EBB Contractor Directory
    "700000007": !this.currentContact.contractorInDirectory,        // Show Not In EBB Contractor Directory
    "700000008": this.currentContact.essContractorInDirectory,      // Show In ESS Contractor Directory
    "700000009": !this.currentContact.essContractorInDirectory,     // Show Not In ESS Contractor Directory
    "700000010": this.currentContact.emrFemaTrained,                // Show EMR Training Completed
    "700000011": !this.currentContact.emrFemaTrained,               // Show EMR Training Not Completed
    "700000012": this.currentContact.emrContractorInDirectory,      // Show In EMR Contractor Directory
    "700000013": !this.currentContact.emrContractorInDirectory,     // Show Not In EMR Contractor Directory
  };

  if (useOrCondition) {
    // OR condition: Return true if any tag matches its condition
    return tags.some(tag => conditions[tag] ?? false);
  } else {
    // AND condition: Return true if all tags match their conditions
    return tags.every(tag => conditions[tag] ?? false);
  }
}


private checkHomeTags(retrofitProgramTypes: string[]): boolean {

 const rpts: number[] = Array.isArray(retrofitProgramTypes)
  ? retrofitProgramTypes
      .map(x => Number(x))
      .filter(x => !Number.isNaN(x))
  : [];
 if(rpts.length ==0){
  return false;
 }
  if (rpts.length > 0 && this.applications.length > 0) {
    // Fallback: any InProgress application with matching programType
    const hasMatch = rpts.some(pt =>
      this.applications.some(app =>
        app.stateCode == 0  &&
        Number(app.programType) === pt
      )
    );
    return !hasMatch;
  }
const allowedStatuses = new Set<number>([700000001, 700000002, 700000004]);
 if (rpts.includes(700000005) && this.applications.length > 0) {
    // Special case: check sGStatus of ANY application
    const hasAllowedStatus = this.applications.some(app =>
      allowedStatuses.has(app.sGStatus ?? -1)
    );
    return !hasAllowedStatus;
  }
  
 if (rpts.length > 0 && this.currentDwellings.length > 0) {
  const hasMatch = rpts.some(pt =>
      this.currentDwellings.some(app =>
        app.stateCode == 0  &&
        Number(app.programCycle?.typeCode) === pt
      )
    );
     return !hasMatch;
  }
  return true; // default hide

}

private hideContactNotification(notificationId: string): void {
    this.apiNotification.saveAssociateNotificationWithContact(this.currentContact.id, notificationId).subscribe(
        data => {
            this.contactNotifications = cloneDeep(data);
            const index = this.shownotifications.findIndex(notification => notification.id === notificationId);
            if (index !== -1) {
                this.shownotifications.splice(index, 1);
            }
            this.visibleNotifications = this.shownotifications.filter(x=>x.hide==false).length > 0;
        },
        error => console.error('Error saving associated notification with contact', error)
    );
}

  public getHelpTextItem( listHelp: IHelp[], text: string): IHelp {
    const item = listHelp.findIndex(
      i => i.name.toLowerCase() === text.toLowerCase()
    );

    if(item < 0){ return null; }

    return this.listHelp[item];
  }

  public onClickSearchIcon(): void {
    this.displaySearchInput = !this.displaySearchInput;
    if (this.displaySearchInput) {
      setTimeout(_ => {
        this.searchPhrase.focus();
      });
    }
  }

  public onClickToggleOpenClosedProjects(): void {
    this.toggleOpenClosedProjects = !this.toggleOpenClosedProjects;
  }

  public onClickToggleInspectedProjects(): void {
    this.toggleInspectedProjects = !this.toggleInspectedProjects;
    this.ngOnInit();
  }

  public toggleHomeDisplayMode(mode: boolean): void {
    this.toggleDisplayCardList = mode;
    const updateContact: IContactInput = {} as IContactInput;

    if (this.toggleDisplayCardList) {
      updateContact.personalizationDashboardHome = 700000000;
    } else {
      updateContact.personalizationDashboardHome = 700000001;
    }

    this.apiContact
      .updateContact(updateContact)
      .subscribe(
        data => data,
        error =>
          console.warn(
            `ERROR: Set contact personalization ${JSON.stringify(error)}`
          )
      );
  }

  public onEmitApplicationChangeEvent(event: boolean): void {
    if(event){
    this.ngOnInit();}
  }
  public redirectToESSTraining() {
    this.router.navigate(['/trainingess']);
  }
  public  redirectToEBBTraining() {
    this.router.navigate(['/trainingebb']);
  }

  public handleClose(notificationId: string): void {
    const notification = this.notifications.find(n => n.id === notificationId);
    if (notification) {
      notification.hide = true;
      this.hideContactNotification(notificationId)
    }
  }
  
}

